"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div.attrs({
    className: "ToggleButtonContainer",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: fit-content;\n  padding: 0.4rem;\n  border-radius: 8px;\n  border: 1px solid\n    ", ";\n  .Button {\n    margin-right: 0.4rem;\n  }\n  .Button:last-child {\n    margin-right: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: fit-content;\n  padding: 0.4rem;\n  border-radius: 8px;\n  border: 1px solid\n    ", ";\n  .Button {\n    margin-right: 0.4rem;\n  }\n  .Button:last-child {\n    margin-right: 0;\n  }\n"])), function (props) {
    return props.variant === "default" ? "var(--black)" : "var(--smoke)";
});
var templateObject_1;
